/* eslint-disable */
export const storeInfo = (storeCode) => ({
    dimension16: storeCode,
});
